import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
} from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { colors } from '../constants';

/**
 * Warns before creating items that have no barcode, offering to generate one,
 * to continue without, or to go back and fill the barcodes in by hand.
 */
export default function MissingBarcodeDialog({
  open,
  lines = [],
  loading = false,
  onCancel,
  onAutogenerate,
  onContinue,
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <ReportProblemOutlinedIcon sx={{ color: colors.warning }} />
          <span>
            {lines.length === 1
              ? '1 new item has no barcode'
              : `${lines.length} new items have no barcode`}
          </span>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: colors.gray600 }}>
          These items will be created without a barcode, so they cannot be
          scanned:
        </Typography>
        <Stack sx={{ mt: 1, mb: 1.5 }}>
          {lines.slice(0, 8).map((line) => (
            <Typography key={line} variant="body2" sx={{ fontWeight: 500 }}>
              • {line}
            </Typography>
          ))}
          {lines.length > 8 && (
            <Typography variant="body2" sx={{ color: colors.gray500 }}>
              ...and {lines.length - 8} more
            </Typography>
          )}
        </Stack>
        <Typography variant="caption" sx={{ color: colors.gray500 }}>
          Generating assigns each of them a unique EAN-13 barcode.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, flexWrap: 'wrap', gap: 1 }}>
        <Button onClick={onCancel} disabled={loading} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button onClick={onContinue} disabled={loading} sx={{ textTransform: 'none' }}>
          Continue without barcode
        </Button>
        <Button
          onClick={onAutogenerate}
          variant="contained"
          disabled={loading}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            backgroundColor: colors.primary,
            '&:hover': { backgroundColor: colors.primaryDark },
          }}
        >
          Generate barcodes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
